'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from '@framework/next/navigation';
import { trace, context as OTelContext, Span } from '@dealroadshow/jsbro/OTel/api';

const PageNavigationInstrumentation = ({ children }: React.PropsWithChildren) => {
  const pathname = usePathname();
  const spanRef = useRef<Span>(null);

  useEffect(() => {
    const tracer = trace.getTracer();
    spanRef.current = tracer.startSpan('page.navigation', {
      attributes: { page: pathname },
    }, OTelContext.active());

    return () => {
      spanRef.current?.end();
    };
  }, [pathname]);

  return children;
};

export default PageNavigationInstrumentation;
